import { render } from "./RestrictionStatisticCard.vue?vue&type=template&id=1bf166c8&scoped=true"
import script from "./RestrictionStatisticCard.vue?vue&type=script&lang=js"
export * from "./RestrictionStatisticCard.vue?vue&type=script&lang=js"

import "./RestrictionStatisticCard.vue?vue&type=style&index=0&id=1bf166c8&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf166c8"]])

export default __exports__